import { FlexCol, FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import { Paragraph } from '@/components/common/Typography';
import { Text } from '@chakra-ui/react';
import { IconName } from '@common/react/icons';
import { useMoneyMarketRatePublic } from '@common/react/rates';

const buildFeatureList = (
    moneyMarketRate: string | undefined
): { iconName: IconName; text: string }[] => {
    const features: { iconName: IconName; text: string }[] = [
        {
            iconName: 'BarChart08',
            text: 'Net worth tracking and forecasting',
        },
        {
            iconName: 'LineChartUp02',
            text: 'Premium portfolios for a low 0.20% investment fee',
        },
        {
            iconName: 'Scales01',
            text: 'Budget & spend tracking for couples',
        },
        {
            iconName: 'PiggyBank01',
            text: 'Goal-based saving and investing plans',
        },
    ];

    if (moneyMarketRate) {
        features.push({
            iconName: 'Percent03',
            text: `${moneyMarketRate} APY* for cash`,
        });
    }

    return features;
};

const PlentyFeatureList = () => {
    const moneyMarketRate = useMoneyMarketRatePublic();

    const featureList = buildFeatureList(moneyMarketRate);

    return (
        <>
            <Paragraph fontWeight="medium" mt={8}>
                Your membership unlocks all these benefits and more:
            </Paragraph>
            <FlexCol gap={5} mt={6}>
                {featureList.map(({ iconName, text }) => (
                    <FlexRow key={text} align="center" gap={4}>
                        <Icon name={iconName} color="blue.500" />
                        <Text fontWeight="medium" fontSize="sm">
                            {text}
                        </Text>
                    </FlexRow>
                ))}
            </FlexCol>
        </>
    );
};

export default PlentyFeatureList;
